import React from 'react';
import { useNavigate } from 'react-router';
import { MdCameraAlt, MdLock } from 'react-icons/md';

export default function PermissionsRequired() {
    const navigate = useNavigate();

    const checkAndRetry = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            stream.getTracks().forEach(t => t.stop());
            navigate('/Camera?p=Camera');
        } catch {
            // Still denied — browser will show its own message; stay on page
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '0 24px 24px',
            background: '#111',
            color: '#fff',
            textAlign: 'center',
            gap: 0,
            overflowY: 'auto',
        }}>
            {/* Icon */}
            <div style={{
                position: 'relative',
                marginBottom: 20,
            }}>
                <MdCameraAlt style={{ fontSize: 64, color: '#ffcc00', opacity: 0.9 }} />
                <MdLock style={{
                    position: 'absolute',
                    bottom: -4,
                    right: -8,
                    fontSize: 26,
                    color: '#ef4444',
                    background: '#111',
                    borderRadius: '50%',
                    padding: 2,
                }} />
            </div>

            <h2 style={{ margin: '0 0 8px', fontSize: '1.2rem', fontWeight: 800, color: '#fff' }}>
                Camera Access Required
            </h2>
            <p style={{ margin: '0 0 28px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5 }}>
                Allow camera access in your browser settings, then tap the button below.
            </p>

            {/* Required permissions */}
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: 'rgba(255,204,0,0.07)',
                border: '1px solid rgba(255,204,0,0.2)',
                borderRadius: 14,
                padding: '14px 18px',
                marginBottom: 12,
                textAlign: 'left',
            }}>
                <p style={{ margin: '0 0 8px', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#ffcc00' }}>
                    Required
                </p>
                <p style={{ margin: '0 0 6px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>
                    Our app needs the following permission to function and won't work without it:
                </p>
                <ul style={{ margin: 0, padding: '0 0 0 18px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.7 }}>
                    <li>Camera — to scan receipts</li>
                </ul>
            </div>

            {/* Optional permissions */}
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: 14,
                padding: '14px 18px',
                marginBottom: 12,
                textAlign: 'left',
            }}>
                <p style={{ margin: '0 0 8px', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'rgba(255,255,255,0.4)' }}>
                    Optional
                </p>
                <p style={{ margin: '0 0 6px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.5 }}>
                    The following permissions are optional:
                </p>
                <ul style={{ margin: 0, padding: '0 0 0 18px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
                    <li>Notifications — from our chat system</li>
                    <li>File access — to upload receipts from your file system</li>
                    <li>Location — to zoom the map to your surroundings</li>
                </ul>
            </div>

            {/* Privacy note */}
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: 'rgba(255,255,255,0.02)',
                borderRadius: 14,
                padding: '12px 18px',
                marginBottom: 28,
                textAlign: 'left',
            }}>
                <p style={{ margin: 0, fontSize: '0.76rem', color: 'rgba(255,255,255,0.35)', lineHeight: 1.6 }}>
                    Your privacy is important to us. Security measures are applied to protect your data.
                    Your data cannot be directly linked to your persona. Anonymous, aggregated data may
                    eventually be used to improve the product. A full privacy policy will follow.
                </p>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: 10, width: '100%', maxWidth: 420 }}>
                <button
                    onClick={checkAndRetry}
                    style={{
                        flex: 2,
                        background: '#ffcc00',
                        color: '#111',
                        border: 'none',
                        borderRadius: 12,
                        padding: '13px 0',
                        fontWeight: 800,
                        fontSize: '0.88rem',
                        cursor: 'pointer',
                        fontFamily: 'inherit',
                    }}
                >
                    Check Permission
                </button>
                <button
                    onClick={() => navigate('/')}
                    style={{
                        flex: 1,
                        background: 'rgba(255,255,255,0.08)',
                        color: 'rgba(255,255,255,0.7)',
                        border: 'none',
                        borderRadius: 12,
                        padding: '13px 0',
                        fontWeight: 700,
                        fontSize: '0.88rem',
                        cursor: 'pointer',
                        fontFamily: 'inherit',
                    }}
                >
                    Go Home
                </button>
            </div>
        </div>
    );
}
